import "./styles.css";
import { colors } from "@/constants";

interface Props {
  scale?: number;
}

const Loading = ({ scale = 1 }: Props) => {
  return (
    <div
      className="loading-content"
      style={{
        maxWidth: "100%",
        width: `${scale * 50}px`,
        height: `${scale * 50}px`,
        transform: `scale(${scale})`,
      }}
    >
      <svg
        width="50"
        height="50"
        fill="none"
        viewBox="0 0 50 50"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_24264_14467)">
          <path
            id="truck"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M41.5041 37.8927C41.1493 37.8927 40.8025 37.7846 40.5075 37.5821C40.2126 37.3796 39.9826 37.0917 39.8469 36.7549C39.7111 36.4181 39.6756 36.0475 39.7448 35.69C39.814 35.3324 39.9849 35.004 40.2357 34.7462C40.4866 34.4884 40.8062 34.3129 41.1541 34.2418C41.5021 34.1706 41.8628 34.2071 42.1905 34.3466C42.5183 34.4862 42.7984 34.7224 42.9955 35.0255C43.1926 35.3286 43.2978 35.685 43.2978 36.0495C43.2968 36.5381 43.1075 37.0063 42.7713 37.3517C42.4352 37.6972 41.9795 37.8917 41.5041 37.8927ZM24.199 37.8927C23.8443 37.8927 23.4975 37.7846 23.2025 37.5821C22.9075 37.3796 22.6776 37.0917 22.5418 36.7549C22.4061 36.4181 22.3705 36.0475 22.4397 35.69C22.509 35.3324 22.6798 35.004 22.9307 34.7462C23.1815 34.4884 23.5011 34.3129 23.8491 34.2418C24.197 34.1706 24.5577 34.2071 24.8855 34.3466C25.2132 34.4862 25.4934 34.7224 25.6905 35.0255C25.8876 35.3286 25.9928 35.685 25.9928 36.0495C25.9918 36.5381 25.8025 37.0063 25.4663 37.3517C25.1301 37.6972 24.6745 37.8917 24.199 37.8927ZM48.4989 25.3606L42.4623 17.6333C42.3128 17.4414 42.1232 17.2866 41.9076 17.1802C41.692 17.0739 41.4558 17.0187 41.2166 17.0189H37.4107C36.9868 17.0189 36.5803 17.1919 36.2805 17.4999C35.9808 17.8079 35.8124 18.2257 35.8124 18.6612V30.6735H33.8002V10.1463C33.8002 9.70966 33.6314 9.29092 33.3309 8.98219C33.0305 8.67345 32.623 8.5 32.1981 8.5H18.4498C18.0256 8.50104 17.6191 8.67495 17.3195 8.98358C17.0198 9.2922 16.8516 9.71034 16.8516 10.1463V34.3875C16.8516 34.8231 17.02 35.2408 17.3197 35.5488C17.6194 35.8568 18.026 36.0298 18.4498 36.0298H19.8488C19.8488 37.2154 20.3071 38.3524 21.123 39.1907C21.9388 40.029 23.0453 40.5 24.199 40.5C25.3528 40.5 26.4593 40.029 27.2751 39.1907C28.0909 38.3524 28.5493 37.2154 28.5493 36.0298H37.1539C37.1539 37.2154 37.6122 38.3524 38.428 39.1907C39.2438 40.029 40.3503 40.5 41.5041 40.5C42.6578 40.5 43.7643 40.029 44.5802 39.1907C45.396 38.3524 45.8543 37.2154 45.8543 36.0298H47.2533C47.6772 36.0298 48.0837 35.8568 48.3834 35.5488C48.6832 35.2408 48.8516 34.8231 48.8516 34.3875V26.3688C48.8523 25.9947 48.7277 25.6318 48.4989 25.3409V25.3606ZM19.7656 12.4092C19.7656 11.8569 20.2133 11.4092 20.7656 11.4092H29.6747C30.227 11.4092 30.6747 11.8569 30.6747 12.4092V28.8637H19.7656V12.4092ZM40.6127 20.1367H38.1875V28.864H45.946V26.6337L40.6127 20.1367Z"
          />
          <rect
            y="26"
            x="6.125"
            id="truck-rect-1"
            width="7.27273"
            height="2.18182"
            fill={colors.brand.grafite}
          />
          <rect
            y="29.6367"
            x="1.75781"
            id="truck-rect-2"
            width="11.6364"
            height="2.18182"
            fill={colors.brand.grafite}
          />
          <rect
            y="33.2734"
            x="3.9375"
            id="truck-rect-3"
            width="9.45455"
            height="2.18182"
            fill={colors.brand.grafite}
          />
        </g>

        <defs>
          <clipPath id="clip0_24264_14467">
            <rect width="50" height="50" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default Loading;
